import {FC, useState} from 'react'
import Indicator from '_core/components/Indicator'
import {useDispatch} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'

interface Props {
  title: string
  onRemoveDiscount: (data: any) => void
  discountCodeId: string | any
}

const RemoveDiscount: FC<Props> = ({title, onRemoveDiscount, discountCodeId}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const dispatch = useDispatch()

  const handleRemoveDiscount = async () => {
    try {
      setIsDeleting(true)
      await onRemoveDiscount(discountCodeId)
    } catch (error) {
      console.error(error)
      console.error(error)
      dispatch(showMessage({text: 'An error occurred while removing discount', variant: 'error'}))
    } finally {
      setIsDeleting(false)
    }
  }
  return (
    <div className='d-flex align-items-center gap-8'>
      <button
        id='btnTabDaysDelete'
        type='button'
        className='btn btn-link p-0 py-2 bg-white text-primary-active fw-bolder'
        onClick={handleRemoveDiscount}
        disabled={isDeleting}
      >
        {isDeleting ? (
          <Indicator text={`Removing ${title} Discount...`} />
        ) : (
          <div>
            Remove <i className='bi bi-trash-fill'></i>
          </div>
        )}
      </button>
      <span className='text-dark'>{title}</span>
    </div>
  )
}

export default RemoveDiscount
